(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-selector"] && !Shopify.designMode) return;
  try {
    (function () {
var initializedRoots = new WeakSet();
var initializedLabels = new WeakSet();
var initializedTestimonials = new WeakSet();

/* Formaterar öre enligt butikens money_format och tar bort ,00 / .00 –
   samma resultat som Liquid-filtret money_without_trailing_zeros */
function formatMoney(cents, format) {
  cents = Math.round(Number(cents) || 0);
  format = format || '{{amount}}';
  var whole = cents % 100 === 0;

  function fmt(precision, thousands, decimal) {
    var parts = (cents / 100).toFixed(precision).split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? intPart + decimal + parts[1] : intPart;
  }

  var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
  if (!match) return format;

  var value;
  switch (match[1]) {
    case 'amount_no_decimals': value = fmt(0, ',', '.'); break;
    case 'amount_with_comma_separator': value = fmt(whole ? 0 : 2, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator': value = fmt(0, '.', ','); break;
    case 'amount_with_apostrophe_separator': value = fmt(whole ? 0 : 2, "'", '.'); break;
    case 'amount_with_space_separator': value = fmt(whole ? 0 : 2, ' ', ','); break;
    case 'amount_no_decimals_with_space_separator': value = fmt(0, ' ', ','); break;
    default: value = fmt(whole ? 0 : 2, ',', '.');
  }

  return format.replace(match[0], value).replace(/<[^>]*>/g, '');
}

/* Pillerväljare för en produkts alternativ (storlek, färg …).
   Hittar rätt variant utifrån valda värden och markerar slutsålda kombinationer. */
function createOptionPicker(container, variants, onSelect) {
  if (!container || !variants.length) return null;
  var groups = Array.prototype.slice.call(container.querySelectorAll('[data-option-index]'));
  if (!groups.length) return null;

  function pillsOf(group) {
    return Array.prototype.slice.call(group.querySelectorAll('.bundle-selector__pill'));
  }

  function currentValues() {
    return groups.map(function (group) {
      var pressed = group.querySelector('.bundle-selector__pill[aria-pressed="true"]');
      return pressed ? pressed.dataset.value : null;
    });
  }

  function findVariant(values, changedIndex) {
    var exact = variants.find(function (v) {
      return v.options.every(function (o, j) { return o === values[j]; });
    });
    if (exact) return exact;
    var candidates = variants.filter(function (v) { return v.options[changedIndex] === values[changedIndex]; });
    return candidates.find(function (v) { return v.available; }) || candidates[0] || null;
  }

  function sync(variant) {
    if (!variant || !variant.options) return;
    var values = variant.options;
    groups.forEach(function (group, i) {
      pillsOf(group).forEach(function (pill) {
        var value = pill.dataset.value;
        var selected = value === values[i];
        pill.classList.toggle('is-selected', selected);
        pill.setAttribute('aria-pressed', selected ? 'true' : 'false');
        var available = variants.some(function (v) {
          return v.available && v.options.every(function (o, j) {
            return j === i ? o === value : o === values[j];
          });
        });
        pill.classList.toggle('is-unavailable', !available);
      });
    });
  }

  groups.forEach(function (group, i) {
    group.addEventListener('click', function (e) {
      var pill = e.target.closest('.bundle-selector__pill');
      if (!pill) return;
      e.preventDefault();
      var values = currentValues();
      values[i] = pill.dataset.value;
      var variant = findVariant(values, i);
      if (!variant) return;
      sync(variant);
      onSelect(variant);
    });
  });

  return { sync: sync };
}

function initBundleSelectors() {

  document.querySelectorAll('[data-testimonial-slider]').forEach(function (slider) {
    if (initializedTestimonials.has(slider)) return;
    initializedTestimonials.add(slider);
    var track = slider.querySelector('[data-testimonial-track]');
    var dots = slider.querySelectorAll('[data-testimonial-dots] button');
    if (!track || !dots.length) return;

    function getStep() {
      var cards = track.children;
      if (cards.length > 1) return cards[1].offsetLeft - cards[0].offsetLeft;
      return track.clientWidth;
    }

    function updateDots() {
      var step = getStep();
      var index = step > 0 ? Math.round(track.scrollLeft / step) : 0;
      index = Math.max(0, Math.min(dots.length - 1, index));
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateDots();
        ticking = false;
      });
    }, { passive: true });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        track.scrollTo({ left: i * getStep(), behavior: 'smooth' });
      });
    });

    window.addEventListener('resize', updateDots);
    updateDots();
  });

  document.querySelectorAll('[data-bundle-label]').forEach(function (label) {
    if (initializedLabels.has(label)) return;
    initializedLabels.add(label);
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          label.classList.add('is-visible');
          observer.unobserve(label);
        }
      });
    }, { threshold: 0.6 });

    observer.observe(label);
  });

  document.querySelectorAll('[data-bundle-selector]').forEach(function (root) {
    if (initializedRoots.has(root)) return;
    initializedRoots.add(root);

    var data = {};
    var dataEl = root.querySelector('[data-bundle-data]');
    try { data = JSON.parse(dataEl ? dataEl.textContent : '{}'); } catch (e) { data = {}; }

    var twoPack = !!data.twoPack;

    var soloById = {};
    (data.solo || []).forEach(function (v) { soloById[String(v.id)] = v; });
    var accById = {};
    (data.accessory || []).forEach(function (v) { accById[String(v.id)] = v; });

    var pct = Number(data.discountPercent) || 0;
    var amount = Number(data.discountAmount) || 0;
    var fixed = Number(data.fixedPrice) || 0;

    var submitBtn = root.querySelector('[data-bundle-submit]');
    var priceLabels = root.querySelectorAll('[data-bundle-price-label]');
    var errorEl = root.querySelector('[data-bundle-error]');
    var bundleRadios = root.querySelectorAll('[data-bundle-option]');
    var soloPriceEl = root.querySelector('[data-solo-price-display]');
    var soloCompareEl = root.querySelector('[data-solo-compare-display]');
    var bundleTotalEl = root.querySelector('[data-bundle-total]');
    var bundleCompareEl = root.querySelector('[data-bundle-compare-display]');
    var soloPickerEl = root.querySelector('[data-option-picker="solo"]');
    var accPickerEl = root.querySelector('[data-option-picker="accessory"]');
    var scope = root.closest('.shopify-section') || document;

    var soloOptionNames = soloPickerEl
      ? Array.prototype.slice.call(soloPickerEl.querySelectorAll('[data-option-index]')).map(function (g) { return g.dataset.optionName || ''; })
      : [];

    var state = {
      soloId: String(root.dataset.soloVariantId || ''),
      accId: String(root.dataset.accessoryVariantId || ''), qty: 1
    };
    var busy = false;
    var soloPicker = null;
    var accPicker = null;

    function money(cents) {
      return formatMoney(cents, data.moneyFormat);
    }

    function regular(v) {
      return v.compare > v.price ? v.compare : v.price;
    }

    /* Den andra produkten i kort 2: i tvåpacksläget samma variant som kort 1, annars tillbehöret */
    function secondVariant() {
      return twoPack ? soloById[state.soloId] : accById[state.accId];
    }

    /* Samma uträkning som i Liquid längst upp i filen */
    function calcBundle(s, a) {
      var total = s.price + a.price;
      var result = total;
      switch (data.discountType) {
        case 'percent_accessory': result = total - Math.round(a.price * pct / 100); break;
        case 'percent_total': result = total - Math.round(total * pct / 100); break;
        case 'amount': result = total - amount; break;
        default: if (fixed > 0) result = fixed;
      }
      return Math.max(0, result);
    }

    function isBundleSelected() {
      var checked = root.querySelector('[data-bundle-option]:checked');
      return !!(checked && checked.value === 'bundle');
    }

    function setCompare(el, cents) {
      if (!el) return;
      if (cents > 0) {
        el.textContent = money(cents);
        el.hidden = false;
      } else {
        el.textContent = '';
        el.hidden = true;
      }
    }

    function render() {
      var s = soloById[state.soloId];
      if (!s) return;
      var a = secondVariant();

      if (soloPriceEl) soloPriceEl.textContent = money(s.price);
      setCompare(soloCompareEl, s.compare > s.price ? s.compare : 0);

      var bundle = s.price;
      if (a) {
        bundle = calcBundle(s, a);
        var combined = regular(s) + regular(a);
        if (bundleTotalEl) bundleTotalEl.textContent = money(bundle);
        setCompare(bundleCompareEl, combined > bundle ? combined : 0);
      }

      var bundleOn = isBundleSelected() && !!a;
      var label = money(bundleOn ? bundle : s.price * state.qty);
      priceLabels.forEach(function (el) { el.textContent = label; });

      var available = s.available && (!bundleOn || a.available);
      if (!busy) submitBtn.disabled = !available;
    }

    /* Vald variant i temats produktformulär (om det finns ett) */
    function readFormVariantId() {
      var input = scope.querySelector('form[action*="/cart/add"] [name="id"]') ||
        document.querySelector('form[action*="/cart/add"] [name="id"]');
      return input && input.value ? String(input.value) : null;
    }

    /* Försöker spegla valet till temats egen variantväljare om den finns på sidan
       (Horizon: <variant-picker>, Dawn: <variant-selects>). */
    function syncThemePicker(variant) {
      var pickers = scope.querySelectorAll('variant-picker, variant-selects, [data-variant-picker]');
      pickers.forEach(function (picker) {
        if (root.contains(picker)) return;
        variant.options.forEach(function (value, i) {
          var name = (soloOptionNames[i] || '').toLowerCase();
          if (!name) return;

          var radios = Array.prototype.slice.call(picker.querySelectorAll('input[type="radio"]'));
          var radio = radios.find(function (r) {
            return r.value === value && (r.name || '').toLowerCase().indexOf(name) === 0;
          });
          if (radio && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }

          picker.querySelectorAll('select').forEach(function (select) {
            var selectName = (select.name || '').toLowerCase();
            if (selectName.indexOf(name) !== 0 && selectName !== 'options[' + name + ']') return;
            var hasValue = Array.prototype.some.call(select.options, function (o) { return o.value === value; });
            if (hasValue && select.value !== value) {
              select.value = value;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
      });
    }

    /* source: 'picker' = blockets piller, 'theme' = temats väljare.
       Tar bara emot ID:n som tillhör den här produkten – ignorerar quick add m.m. */
    function setSoloVariant(id, source) {
      id = String(id);
      var variant = soloById[id];
      if (!variant || id === state.soloId) return;
      state.soloId = id;
      root.dataset.soloVariantId = id;
      if (soloPicker && source !== 'picker') soloPicker.sync(variant);
      if (source === 'picker') syncThemePicker(variant);
      render();
    }

    function selectBundle() {
      var bundleRadio = root.querySelector('[data-bundle-option][value="bundle"]');
      if (bundleRadio && !bundleRadio.disabled && !bundleRadio.checked) {
        bundleRadio.checked = true;
        bundleRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    soloPicker = createOptionPicker(soloPickerEl, data.solo || [], function (variant) {
      setSoloVariant(variant.id, 'picker');
    });

    accPicker = createOptionPicker(accPickerEl, data.accessory || [], function (variant) {
      state.accId = String(variant.id);
      root.dataset.accessoryVariantId = state.accId;
      selectBundle();
      render();
    });

    /* Horizon-teman skickar variant:update, Dawn-liknande teman ett change-event på id-fältet */
    document.addEventListener('variant:update', function (e) {
      var variant = e.detail && e.detail.resource;
      if (variant && variant.id) setSoloVariant(variant.id, 'theme');
    });

    scope.addEventListener('change', function (e) {
      var target = e.target;
      if (target && target.name === 'id' && target.closest('form[action*="/cart/add"]')) {
        setSoloVariant(target.value, 'theme');
      }
    });

    bundleRadios.forEach(function (radio) {
      radio.addEventListener('change', render);
    });

    if (soloPicker) {
      soloPicker.sync(soloById[state.soloId]);
    } else {
      var initialFormId = readFormVariantId();
      if (initialFormId) setSoloVariant(initialFormId, 'theme');
    }
    var klarnaEl = null; function dockKlarna() { if (!klarnaEl) return; klarnaEl.classList.remove('is-docked'); var host = root.closest('.shopify-block') || root; var priceEl = host.previousElementSibling; if (!priceEl || priceEl.tagName !== 'PRODUCT-PRICE') return; var pill = klarnaEl.firstElementChild; var pr = priceEl.getBoundingClientRect(); var rr = root.getBoundingClientRect(); var range = document.createRange(); range.selectNodeContents(priceEl); var tr = range.getBoundingClientRect(); var textW = tr.width; if (!pr.height || textW + pill.offsetWidth + 16 > rr.width) return; klarnaEl.style.setProperty('--klarna-top', Math.round(tr.top + tr.height / 2 - rr.top - pill.offsetHeight / 2) + 'px'); klarnaEl.classList.add('is-docked'); var klarnaFix = (tr.top + tr.height / 2 - pill.offsetHeight / 2) - pill.getBoundingClientRect().top; if (Math.abs(klarnaFix) > 0.5) klarnaEl.style.setProperty('--klarna-top', Math.round(tr.top + tr.height / 2 - rr.top - pill.offsetHeight / 2 + klarnaFix) + 'px'); } if (klarnaEl) { dockKlarna(); window.addEventListener('resize', dockKlarna); if (document.fonts && document.fonts.ready) document.fonts.ready.then(dockKlarna); if (window.ResizeObserver) { var klarnaHost = root.closest('.shopify-block'); var klarnaPrice = klarnaHost && klarnaHost.previousElementSibling; if (klarnaPrice) new ResizeObserver(dockKlarna).observe(klarnaPrice); } } var qtyValueEl = root.querySelector('[data-qty-value]'); var qtyMinusEl = root.querySelector('[data-qty-step="-1"]'); root.querySelectorAll('[data-qty-step]').forEach(function (btn) { btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); var delta = Number(btn.dataset.qtyStep); var next = Math.max(1, Math.min(99, state.qty + delta)); if (next === state.qty) return; state.qty = next; if (qtyValueEl) { qtyValueEl.textContent = next; qtyValueEl.classList.remove('is-up', 'is-down'); void qtyValueEl.offsetWidth; qtyValueEl.classList.add(delta > 0 ? 'is-up' : 'is-down'); } if (qtyMinusEl) qtyMinusEl.classList.toggle('is-min', next <= 1); render(); }); }); if (accPicker) accPicker.sync(accById[state.accId]);
    render();

    submitBtn.addEventListener('click', function () {
      /* Har blocket egna piller är de facit – annars läses temats formulär */
      if (!soloPicker) {
        var formId = readFormVariantId();
        if (formId) setSoloVariant(formId, 'theme');
      }

      var bundleOn = isBundleSelected() && !!secondVariant();
      var items;

      if (bundleOn && twoPack) {
        /* Tvåpack: en rad med antal 2 i vald storlek */
        items = [{ id: Number(state.soloId), quantity: 2 }];
      } else {
        items = [{ id: Number(state.soloId), quantity: state.qty }];
        if (bundleOn) {
          items.push({ id: Number(state.accId), quantity: 1 });
        }
      }

      errorEl.hidden = true;
      busy = true;
      submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data.description || 'Could not add to cart');
            });
          }
          return response.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
  ? window.Shopify.routes.root + 'checkout'
  : '/checkout';
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
          busy = false;
          render();
        });
    });

    var sizeChartOpenBtn = root.querySelector('[data-size-chart-open]');
    var sizeChartOverlay = root.querySelector('[data-size-chart-overlay]');
    var sizeChartCloseBtn = root.querySelector('[data-size-chart-close]');

    if (sizeChartOpenBtn && sizeChartOverlay) {
      function closeSizeChart() {
        sizeChartOverlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      sizeChartOpenBtn.addEventListener('click', function () {
        sizeChartOverlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });

      if (sizeChartCloseBtn) {
        sizeChartCloseBtn.addEventListener('click', closeSizeChart);
      }

      sizeChartOverlay.addEventListener('click', function (e) {
        if (e.target === sizeChartOverlay) closeSizeChart();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sizeChartOverlay.classList.contains('is-open')) {
          closeSizeChart();
        }
      });
    }
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBundleSelectors, { once: true });
} else {
  initBundleSelectors();
}
document.addEventListener('shopify:section:load', initBundleSelectors);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bundle-selectorcopy"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-bundle-label-copy]').forEach(function (label) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          label.classList.add('is-visible');
          observer.unobserve(label);
        }
      });
    }, { threshold: 0.6 });

    observer.observe(label);
  });

  document.querySelectorAll('[data-bundle-selector-copy]').forEach(function (root) {
    var soloVariantId = root.dataset.soloVariantId;
    var accessoryVariantId = root.dataset.accessoryVariantId;
    var soloPrice = parseInt(root.dataset.soloPrice, 10);
    var bundlePrice = parseInt(root.dataset.bundlePrice, 10);
    var submitBtn = root.querySelector('[data-bundle-submit-copy]');
    var priceLabels = root.querySelectorAll('[data-bundle-price-label-copy]');
    var errorEl = root.querySelector('[data-bundle-error-copy]');
    var radios = root.querySelectorAll('input[type="radio"]');

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format || null);
      }
      return (cents / 100).toFixed(2);
    }

    function updatePriceLabel() {
      var selected = root.querySelector('input[type="radio"]:checked').value;
      var total = selected === 'bundle' ? bundlePrice : soloPrice;
      priceLabels.forEach(function (el) {
        el.textContent = formatMoney(total);
      });
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', updatePriceLabel);
    });

    submitBtn.addEventListener('click', function () {
      var selected = root.querySelector('input[type="radio"]:checked').value;
      var items = [{ id: soloVariantId, quantity: 1 }];

      if (selected === 'bundle') {
        items.push({ id: accessoryVariantId, quantity: 1 });
      }

      errorEl.hidden = true;
      submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data.description || 'Could not add to cart');
            });
          }
          return response.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart'
            : '/cart';
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
          submitBtn.disabled = false;
        });
    });

    var sizeChartOpenBtn = root.querySelector('[data-size-chart-open-copy]');
    var sizeChartOverlay = root.querySelector('[data-size-chart-overlay-copy]');
    var sizeChartCloseBtn = root.querySelector('[data-size-chart-close-copy]');

    if (sizeChartOpenBtn && sizeChartOverlay) {
      function closeSizeChart() {
        sizeChartOverlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      sizeChartOpenBtn.addEventListener('click', function () {
        sizeChartOverlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });

      if (sizeChartCloseBtn) {
        sizeChartCloseBtn.addEventListener('click', closeSizeChart);
      }

      sizeChartOverlay.addEventListener('click', function (e) {
        if (e.target === sizeChartOverlay) closeSizeChart();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sizeChartOverlay.classList.contains('is-open')) {
          closeSizeChart();
        }
      });
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["stock-warning"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-stock-warning]').forEach(function (block) {
  var sweepEl = block.querySelector('[data-radar-sweep]');
  var radarBox = block.querySelector('[data-radar-box]');
  if (!sweepEl || !radarBox) return;

  var sensitivity = parseFloat(block.getAttribute('data-scroll-sensitivity')) || 0.6;
  var rotation = 0;
  var lastScrollY = window.scrollY;
  var ticking = false;

  function updateRadar() {
    var currentScrollY = window.scrollY;
    var delta = currentScrollY - lastScrollY;
    lastScrollY = currentScrollY;
    
    rotation += delta * sensitivity;

    var baseScale = 1.0;
    var scale = baseScale + (currentScrollY * 0.0012);

    radarBox.style.transform = 'translate(-50%, -50%) scale(' + scale + ')';
    sweepEl.style.transform = 'rotate(' + rotation + 'deg)';
    
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateRadar);
      ticking = true;
    }
  }, { passive: true });
});

// Intersection observer to trigger animations when visible
(function() {
  const container = document.currentScript ? document.currentScript.previousElementSibling : document.querySelector('.stock-folder-container-{{ block.id }}');
  if (!container) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  observer.observe(container);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["stock-warningcopy"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-stock-warning]').forEach(function (block) {
  var sweepEl = block.querySelector('[data-radar-sweep]');
  var radarBox = block.querySelector('[data-radar-box]');
  if (!sweepEl || !radarBox) return;

  var sensitivity = parseFloat(block.getAttribute('data-scroll-sensitivity')) || 0.6;
  var rotation = 0;
  var lastScrollY = window.scrollY;
  var ticking = false;

  function updateRadar() {
    var currentScrollY = window.scrollY;
    var delta = currentScrollY - lastScrollY;
    lastScrollY = currentScrollY;
    
    rotation += delta * sensitivity;

    var baseScale = 1.0;
    var scale = baseScale + (currentScrollY * 0.0012);

    radarBox.style.transform = 'translate(-50%, -50%) scale(' + scale + ')';
    sweepEl.style.transform = 'rotate(' + rotation + 'deg)';
    
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateRadar);
      ticking = true;
    }
  }, { passive: true });
});

/* Krymp & blur vid nedscrollning (endast mobil), reverseras vid uppscrollning */
(function() {
  if (window.innerWidth > 768) return;

  const container = document.querySelector('.stock-folder-container-{{ block.id }}');
  if (!container) return;

  let progress = 0;
  let lastScrollY = window.scrollY;
  let ticking = false;

  const maxScaleReduction = 0.2;  // krymper till 80% vid full effekt
  const maxBlur = 10;             // px vid full effekt
  const maxOpacityReduction = 0.8; // tonar ner till 20% opacitet vid full effekt
  const sensitivity = 400;        // px scroll som krävs för full effekt (lägre = snabbare)

  function applyEffect() {
    const scaleVal = 1 - (progress * maxScaleReduction);
    const blurVal = progress * maxBlur;
    const opacityVal = 1 - (progress * maxOpacityReduction);

    container.style.filter = `blur(${blurVal}px)`;
    container.style.transform = `scale(${scaleVal})`;
    container.style.opacity = opacityVal;

    ticking = false;
  }

  window.addEventListener('scroll', function () {
    const currentScrollY = window.scrollY;
    const delta = currentScrollY - lastScrollY;
    lastScrollY = currentScrollY;

    progress += delta / sensitivity;
    if (progress > 1) progress = 1;
    if (progress < 0) progress = 0;

    if (!ticking) {
      requestAnimationFrame(applyEffect);
      ticking = true;
    }
  }, { passive: true });
})();
  } catch(e) { console.error(e); }
})();

})();
